import Segment from './Segment';
export default Segment;
